export const PAGE = "PAGE";
export const PAGE_CHANGE = "PAGE_CHANGE";
export const TAB_CHANGE = "TAB_CHANGE";
export const DETAILS_CHANGE = "DETAILS_CHANGE";
export const TAB = "TAB";
export const DETAILS = "DETAILS";
export const ERROR = "ERROR";

